export const LANGUAGES = {
  EN: 'en',
  DE: 'de',
};

export const LOCAL_STORAGE_VARS = {
  SITE_LANGUAGE: 'lang',
};
